export const cancelBubbling = (event) => {
    event.stopPropagation();
};
export const redispatcher = (emmiter, shouldCancelBubbling = false) => (event) => {
    if (shouldCancelBubbling) {
        cancelBubbling(event);
    }
    emmiter.emit(event.detail);
};
